import { DECIMAL_INPUT_TEXTS as TEXTS } from '../common/components/inputs/decimalInputTexts';

const DIGITS_AND_ONE_POINT = /^\d*\.?\d*$/;

/**
 * Valida lo que escribe el usuario: devuelve el valor con punto decimal o el aviso a mostrar.
 * @param {string} raw Texto tal como se escribió.
 * @param {number} decimals Máximo de decimales.
 * @returns {{ value?: string, warning?: string }}
 */
export const parseDecimalInput = (raw, decimals) => {
  const normalized = String(raw).replace(/\s/g, '').replace(/,/g, '.');
  if ((normalized.match(/\./g) || []).length > 1) return { warning: TEXTS.thousands };
  if (!DIGITS_AND_ONE_POINT.test(normalized)) return { warning: TEXTS.invalid };
  const fraction = normalized.split('.')[1] || '';
  if (fraction.length > decimals) return { warning: TEXTS.decimals(decimals) };
  return { value: normalized };
};
